(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  if (header) {
    header.classList.remove('shopify-section-header-hidden');
    header.classList.remove('scrolled-past-header');
    header.classList.remove('shopify-section-header-sticky');
  }
});

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener(
      'change',
      this.setHeaderHeight.bind(this)
    );

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop =
      window.scrollY || document.documentElement.scrollTop;

    window.addEventListener('DOMContentLoaded', () => {
      this.onScroll();
    });

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop === 0) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    } else if (scrollTop > this.currentScrollTop) {
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else {
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.reveal.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal ||
      this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }
}

customElements.define('sticky-header', StickyHeader);

// Language selector with flags
document.addEventListener('DOMContentLoaded', function() {
  // Funcție universală pentru toggle dropdown
  function handleLanguageToggle(button, isMobile = false) {
    const dropdown = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Închide toate dropdown-urile
    document.querySelectorAll('.language-dropdown').forEach(d => d.hidden = true);
    document.querySelectorAll('.language-toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
    
    // Deschide dropdown-ul curent
    button.setAttribute('aria-expanded', !isExpanded);
    dropdown.hidden = isExpanded;
    
    // Debugging
    console.log(`Dropdown ${isExpanded ? 'closed' : 'opened'} on ${isMobile ? 'mobile' : 'desktop'}`);
  }

  // Inițializare event listeners
  function initLanguageSelectors() {
    // Desktop
    document.querySelectorAll('.language-selector:not(.mobile-language-selector) .language-toggle').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        handleLanguageToggle(this);
      });
    });

    // Mobile
    document.querySelectorAll('.mobile-language-selector .language-toggle').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleLanguageToggle(this, true);
      });
    });

    // Schimbare limbă (comun)
    document.querySelectorAll('.language-dropdown a').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const form = this.closest('form');
        if (form) {
          const input = form.querySelector('input[name="language_code"]');
          input.value = this.dataset.value;
          form.submit();
        }
      });
    });
  }

  // Reinițializare la resize (pentru switch desktop/mobile)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('.language-toggle').forEach(btn => {
        btn.removeEventListener('click', handleLanguageToggle);
      });
      initLanguageSelectors();
    }, 250);
  });

  // Primul load
  initLanguageSelectors();

  // Închidere la click în afara (comun)
  document.addEventListener('click', function(e) {
    const isDesktop = window.innerWidth >= 750;
    const selector = isDesktop ? '.language-selector:not(.mobile-language-selector)' : '.mobile-language-selector';
    
    if (!e.target.closest(selector)) {
      document.querySelectorAll('.language-dropdown').forEach(d => d.hidden = true);
      document.querySelectorAll('.language-toggle').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });
});



  } catch(e) { console.error(e); }
})();
})();
